import type { LightweightElementsRecord } from "@/store/lightweight-elements-slice";
import { GUID } from "@faro-lotv/foundation";

/**
 * Collects the label ids of an element and, optionally, of all its descendants
 *
 * @param elementId the id of the element to start from
 * @param includeDescendants whether to also collect the labels of the descendants
 * @param lightweightElements the lightweight elements record
 * @param labelIdSet the accumulator set of label ids
 * @returns the accumulator set, filled with the collected label ids
 */
export function collectElementLabelIds(
  elementId: GUID,
  includeDescendants: boolean,
  lightweightElements: LightweightElementsRecord,
  labelIdSet: Set<GUID>,
): Set<GUID> {
  const element = lightweightElements[elementId];
  if (!element) return labelIdSet;

  for (const labelId of element.labelIds ?? []) {
    labelIdSet.add(labelId);
  }

  if (includeDescendants) {
    for (const childId of element.childrenIds ?? []) {
      collectElementLabelIds(
        childId,
        includeDescendants,
        lightweightElements,
        labelIdSet,
      );
    }
  }

  return labelIdSet;
}
